import React from 'react';
import {render} from 'react-dom';
import $ from 'jquery';
import Module from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/Module';
import ModuleButton from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/ModuleButton';
import {default as ButtonCard} from '@sinclair-digital/sbg-storyline-components/src/components/ButtonCard';
import {View} from 'backbone';

import mediaListView from 'views/media/mediaListView';
import {getVisibleModuleButtons} from 'modules';
import {hasGlobalPermissionSet} from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/AppContext';
import {bindAllMethods} from '@sinclair-digital/stl-common/src/backboneHelpers';
import {logout} from '../../js/logout';

/* global globalThis */

globalThis.logTiming = globalThis.logTiming || function () {};

export const HomeView = View.extend({
    debuggingName: 'Home View',
    initialize({appContext}) {
        bindAllMethods(this);
        this.appContext = appContext;
        this.render();
    },
    el: '#admin-main',
    sdaPageTitle: '',
    navId: 'admin-home-tab',
    events: {
        'click .js-addMedia': '_addMediaClickHandler',
    },
    render() {
        const homePageButtons = getVisibleModuleButtons(this.appContext, 'HomePage');
        globalThis.logTiming(`HomeView is rendering`);
        render(
            <div className="app-content">
                <ul id="admin-pins-list" className="sda-card-list thumbnail-view">
                    {homePageButtons.map(({className, id, key, text, ...props}) => (
                        <li
                            key={key}
                            {...{
                                className,
                                id,
                            }}>
                            <ButtonCard {...props}>{text}</ButtonCard>
                        </li>
                    ))}
                </ul>
                <input
                    id="sda-home-upload"
                    type="file"
                    style={{display: 'none'}}
                    multiple={true}
                    capture="true"
                    onChange={e => this._changeToUploadMediaView(e)}
                />
            </div>,
            this.el,
        );

        return this;
    },
    _addMediaClickHandler() {
        $('#sda-home-upload').click();
        return false;
    },
    _changeToUploadMediaView(e) {
        const target = e.dataTransfer || e.target;
        const files = target && target.files && target.files;
        const opts = {
            viewClass: mediaListView,
            id: null,
            files,
            upload: true,
        };

        this.routeChangerData('/media', 'success', 'Processing Media', null, opts);
    },
});

export const homeModule = new Module({
    moduleName: 'Home',
    title: 'Home',
    route: '(home)(/)',
    showNav: true,
    moduleButtons: [
        ModuleButton({
            id: 'admin-home-tab',
            href: '#home',
            text: 'home',
            location: 'Nav',
            buttonType: 'nav',
            priority: 0,
        }),
        // HACK defining nav buttons for parts of the app that haven't been converted to modules yet).
        ModuleButton({
            id: 'admin-properties-tab',
            location: 'Nav',
            buttonType: 'nav',
            priority: 7,
            checkVisible: hasGlobalPermissionSet('properties.view'),
            href: '#property',
            text: 'properties',
        }),
        ModuleButton({
            id: 'admin-media-tab',
            location: 'Nav',
            buttonType: 'nav',
            priority: 8,
            checkVisible: hasGlobalPermissionSet('media.view'),
            href: '#media',
            text: 'media',
        }),
        ModuleButton({
            id: 'admin-user-tab',
            location: 'Nav',
            buttonType: 'nav',
            priority: 20,
            checkVisible: hasGlobalPermissionSet('user-admin.view'),
            href: '#admin',
            text: 'user admin',
        }),
        ModuleButton({
            id: 'sda-sign-out-mobile',
            location: 'Nav',
            buttonType: 'nav',
            className: 'nav-mobile-visible',
            href: '#',
            text: 'sign out',
            priority: 30,
            onClick: (event) => {
                event.preventDefault();
                logout();
            },
        }),
        ModuleButton({
            id: 'add_media_home_button',
            text: 'Add Media',
            href: '#media',
            className: 'js-addMedia',
            backgroundSrc: '../img/home-cards/add_media.jpg',
            checkVisible: hasGlobalPermissionSet('media.upload'),
            priority: 3,
            buttonType: 'card',
            location: 'HomePage',
        }),
        ModuleButton({
            id: 'new_property_home_button',
            text: 'New Property',
            href: '#property/new',
            backgroundSrc: '../img/home-cards/new_property.jpg',
            checkVisible: hasGlobalPermissionSet('property.create'),
            priority: 4,
            buttonType: 'card',
            location: 'HomePage',
        }),
        ModuleButton({
            id: 'manage_users_home_button',
            text: 'Manage Users',
            href: '#admin',
            backgroundSrc: '../img/home-cards/manage_users.jpg',
            checkVisible: hasGlobalPermissionSet('user-admin.view'),
            priority: 5,
            buttonType: 'card',
            location: 'HomePage',
        }),
        ModuleButton({
            id: 'properties_home_button',
            text: 'Properties',
            href: '#property',
            backgroundSrc: '../img/home-cards/new_property.jpg',
            checkVisible: hasGlobalPermissionSet('property.view'),
            priority: 6,
            buttonType: 'card',
            location: 'HomePage',
        }),
    ],

    view: HomeView,
});
